import Label from './Label.vue';
import LabelList from './LabelList.vue';
export default {
  Label,
  LabelList,
};
